
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import About from "./pages/About";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Locations from "./pages/Locations";
import SoborgLocation from "./pages/locations/Soborg";
import CopenhagenLocation from "./pages/locations/Copenhagen";
import OnlineLocation from "./pages/locations/Online";
import GladsaxeLocation from "./pages/locations/Gladsaxe";
import LyngbyLocation from "./pages/locations/Lyngby";
import GentofeLocation from "./pages/locations/Gentofte";
import BuddingeLocation from "./pages/locations/Buddinge";
import EmdrupLocation from "./pages/locations/Emdrup";
import NordvestLocation from "./pages/locations/Nordvest";
import NorrebroLocation from "./pages/locations/Norrebro";
import VangedeLocation from "./pages/locations/Vangede";
import DyssegardLocation from "./pages/locations/Dyssegard";
import BeginnerPianoLessons from "./pages/BeginnerPianoLessons";
import ExperiencedPianoLessons from "./pages/ExperiencedPianoLessons";
import ChildrenPianoLessons from "./pages/ChildrenPianoLessons";
import AdultBeginnerPianoLessons from "./pages/AdultBeginnerPianoLessons";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/om" element={<About />} />
            <Route path="/undervisning" element={<Services />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/lokationer" element={<Locations />} />
            
            {/* Location specific pages */}
            <Route path="/klaverundervisning-soborg" element={<SoborgLocation />} />
            <Route path="/klaverundervisning-kobenhavn" element={<CopenhagenLocation />} />
            <Route path="/klaverundervisning-online" element={<OnlineLocation />} />
            <Route path="/klaverundervisning-gladsaxe" element={<GladsaxeLocation />} />
            <Route path="/klaverundervisning-lyngby" element={<LyngbyLocation />} />
            <Route path="/klaverundervisning-gentofte" element={<GentofeLocation />} />
            <Route path="/klaverundervisning-buddinge" element={<BuddingeLocation />} />
            <Route path="/klaverundervisning-emdrup" element={<EmdrupLocation />} />
            <Route path="/klaverundervisning-nordvest" element={<NordvestLocation />} />
            <Route path="/klaverundervisning-norrebro" element={<NorrebroLocation />} />
            <Route path="/klaverundervisning-vangede" element={<VangedeLocation />} />
            <Route path="/klaverundervisning-dyssegard" element={<DyssegardLocation />} />
            
            {/* Specialized teaching pages */}
            <Route path="/klaverundervisning-begyndere" element={<BeginnerPianoLessons />} />
            <Route path="/klaverundervisning-ovede" element={<ExperiencedPianoLessons />} />
            <Route path="/klaverundervisning-born" element={<ChildrenPianoLessons />} />
            <Route path="/klaverundervisning-voksne" element={<AdultBeginnerPianoLessons />} />
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
